import * as React from 'react';
import { QuestionnaireEvaluationQuestionType } from "../../questionnaireEvaluation";
import { removeNestedAttachmentsOnOptionChange, isArtifactIdExist, attachedArtifactIdsToUpdate } from '../utilities';
import { PhotoCaptureConstants } from '../constants';
export const usePhotoCaptureBasicWorker = ({ isSaveSuccess, companyCode, evaluationDocId, questionnaireId, questionnaireQuestionId, contextId, isContextUpdated, isTermsAndConditionAccepted, photoCaptureAttachmentInfo, answerList, parentQuestionId, attachedArtifactIds, photoCaptureUpdateAttachmentDataSuccessAction, photoCaptureUpdateAttachedArtifactIdSuccessAction, photoCaptureUpdateContextDataAction, questionnaireEvaluationQuestionGetAction, questionnaireEvaluationSaveRequestAction, photoCaptureResetContextAction }) => {
    const [answerValue, setAnswerValue] = React.useState('');
    const [hasChoiceChanged, setHasChoiceChanged] = React.useState(false);
    const [complexAnswerList, setComplexAnswerList] = React.useState(null);
    const changeQuestion = (evaluationDocId, questionnaireId, questionnaireQuestionId, questionType) => {
        photoCaptureResetContextAction();
        const questionGetParams = {
            companyCode,
            evaluationDocId: parseInt(evaluationDocId),
            questionnaireId: parseInt(questionnaireId),
            questionnaireQuestionId,
            questionType
        };
        questionnaireEvaluationQuestionGetAction(questionGetParams);
    };
    React.useEffect(() => {
        isSaveSuccess &&
            evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.NEXT);
    }, [isSaveSuccess]);
    React.useEffect(() => {
        hasChoiceChanged && updateContext();
    }, [hasChoiceChanged]);
    React.useEffect(() => {
        if (hasChoiceChanged && isContextUpdated) {
            photoCaptureUpdateAttachmentDataSuccessAction(removeNestedAttachmentsOnOptionChange(questionnaireQuestionId, photoCaptureAttachmentInfo, attachedArtifactIds));
            setHasChoiceChanged(false);
        }
        if (evaluationDocId && questionnaireQuestionId && isContextUpdated) {
            const saveQuestionParams = {
                isCacheOnly: false,
                evalId: evaluationDocId,
                coCode: companyCode,
                shouldIncludeEvalution: false,
                questionsData: [
                    {
                        qustnnrQustnId: questionnaireQuestionId,
                        answer: answerValue || null,
                        complexAnswerList
                    }
                ]
            };
            questionnaireEvaluationSaveRequestAction(saveQuestionParams);
        }
    }, [isContextUpdated]);
    const updateContextParams = {
        attachmentInfo: hasChoiceChanged
            ? removeNestedAttachmentsOnOptionChange(questionnaireQuestionId, photoCaptureAttachmentInfo, attachedArtifactIds)
            : photoCaptureAttachmentInfo,
        documentId: evaluationDocId,
        fraudWarningAccept: PhotoCaptureConstants.ZERO_STRING,
        isTermsAndConditionAccepted: isTermsAndConditionAccepted ? PhotoCaptureConstants.Y : PhotoCaptureConstants.N,
        status: null,
        vehicle: null
    };
    const updateContext = (contextDataUpdateInput = updateContextParams) => {
        photoCaptureUpdateContextDataAction(contextDataUpdateInput, contextId, companyCode);
    };
    const moveNext = (value) => {
        if (Array.isArray(value)) {
            setComplexAnswerList(value);
            updateContext();
        }
        else {
            setAnswerValue(value);
            const selectedAnswer = answerList && answerList.find((item) => item.answered);
            if (selectedAnswer && value !== selectedAnswer.defaultAnswerDisplayText)
                setHasChoiceChanged(true);
            else
                updateContext();
        }
    };
    const movePrevious = () => {
        const attachedArtifactId = {
            parentQuestionId,
            questionnaireQuestionId
        };
        if (!isArtifactIdExist(attachedArtifactIds, attachedArtifactId)) {
            questionnaireQuestionId &&
                photoCaptureUpdateAttachedArtifactIdSuccessAction(attachedArtifactIdsToUpdate(attachedArtifactIds, attachedArtifactId));
        }
        evaluationDocId &&
            questionnaireId &&
            questionnaireQuestionId &&
            changeQuestion(evaluationDocId, questionnaireId, questionnaireQuestionId, QuestionnaireEvaluationQuestionType.PREVIOUS);
    };
    return { moveNext, movePrevious };
};
//# sourceMappingURL=usePhotoCaptureBasicWorker.js.map